// This file we are not using. need to remove
angular.module('cvsApp').service('verifyAnswerService',['networkService', 'xdrService', 'configManager', 'commonModel', function (NS, XS,CM, CMOD) {
   	
	function verifyAnswerService (){
		var self = this;
		this.verify = function(data, callBackSuccess){
			var url = CM.getAPIUrlWithOtherInfo('VERIFY_ANSWER',cvsUtility.queryMap.tokenId,"Login");
			url=removeURLParameter(url,"serviceCors");
			if(url === "URL_ERROR"){

			}else{
				var request = {url:url,
							header:{"Content-Type":"application/xml",
							"Accept":"application/xml"},
							data:getRequestBody(data),
							onSuccess:callBackSuccess
						};
			
				cvsUtility.commonServiceCode(url,"lookup",self,request,callBackSuccess,NS);
			}
						
		};

		var getRequestBody = function(data){

			return cvsUtility.JSONToXml(data);
		}

		var response = '';

		this.setResponse = function(data){
			data = data.replace(/[\n\r\t]+/g,"");
			response = cvsUtility.xmlToJSON(data);

		};
		this.getResponse = function(){
			return response;
		};
	}
	
	return new verifyAnswerService();
}]);
